import React, {Component} from 'react';
import API from "../../services/API";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faClock, faDownload, faEdit,
    faMapMarker, faUpload,

} from "@fortawesome/free-solid-svg-icons";
import NeshanMap from "react-neshan-map-leaflet";


/*import {MapContainer, TileLayer, Marker} from 'react-leaflet'
import L from 'leaflet';
import "leaflet/dist/leaflet.css"
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';*/

/*let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;*/
const currencyFormat = Intl.NumberFormat('en-US');

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    let R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2-lat1);  // deg2rad below
    let dLon = deg2rad(lon2-lon1);
    let a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
    ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return Math.round(R * c); // Distance in km

}

function deg2rad(deg) {
    return deg * (Math.PI/180)
}
class RequestProfile extends Component {
    state = {
        request: [],
        document_file: null,
        document_description: '',
        document_title: '',
        buttonStatus: "",
        buttonText : "ارسال فایل",
        loading: "d-none",
        loadMap : 0,
        address : '',
        distance : 0
    }
    onDocChange = (event) => {
        this.setState({
            document_file: event.target.files[0]
        })
    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }
    onUploadClick = () => {
        const formData = new FormData();
        const file = this.state.document_file;
        if (file) {
            formData.append('document_file', file);
            if (!this.state.document_title) {
                toast.error('لطفا عنوان فایل ارسالی را مشخص کنید');
                return false;
            }
        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        formData.append('document_title', '-CFD0-' + this.state.document_title);
        formData.append('document_description', this.state.document_description );
        formData.append('id', this.state.request.id);

        API.requestDocument(formData)
            .then((response) => {
                toast.success(response.user_message);
                API.request(this.props.match.params.id)
                    .then((response) => {
                        const request = response.results.request;
                        this.setState({request})
                        this.setState({
                            document_file: [],
                            document_title: '',
                            document_description: ''
                        })
                    })
                const buttonText  = 'ارسال فایل'
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    DriverPositionRequest = () => {
        API.callDriverPosition(this.state.request.driver.id)
            .then((response) => {
               toast.success(response.user_message)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }

    render() {
        let hasDriver = 0;
        let hasBackupDriver = 0;
        let hasLocation = 0;
        if (typeof (this.state.request.backup_driver) !== 'undefined') {
            hasBackupDriver = Object.keys(this.state.request.backup_driver).length;
        }

        if (typeof (this.state.request.driver) !== 'undefined') {
            hasDriver = Object.keys(this.state.request.driver).length;
            if (typeof (this.state.request.driver.location) !== 'undefined') {
                if(this.state.request.status.id > 2 && this.state.request.status.id < 7)
                 hasLocation = Object.keys(this.state.request.driver.location).length;
            }
        }
        let hasDocument = 0;
        if (typeof (this.state.request.documents) !== 'undefined') {
            hasDocument = Object.keys(this.state.request.documents).length;
        }


        return (
            <React.Fragment>

                <Toast/>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>


                            <div className="text-center my-5 text-secondary">
                                <h2>
                                    <strong>مشاهده اطلاعات درخواست</strong>

                                </h2>

                            </div>
                            {
                                this.state.request.status ?

                                    <React.Fragment>
                                        <section className="container rtl my-5 px-3  usual-content super-small pt-4  ">
                                            <div className="row">
                                                <div className="col-md-6 px-3 pb-3 ">
                                                    کد پیگیری (شماره بارنامه) :
                                                    &nbsp;
                                                    <b>
                                                        {this.state.request.tracking_code}
                                                    </b>
                                                </div>
                                                <div className="col-md-6 px-3 pb-3 text-left ">
                                                    وضعیت درخواست:
                                                    &nbsp;
                                                    <b style={{color: this.state.request.status.color}}>
                                                        {this.state.request.status.title}
                                                    </b>
                                                </div>
                                                {
                                                    this.state.request.waybill ?

                                                <div className="col-12 text-center">
                                                    <a href={this.state.request.waybill} title="دانلود بارنامه"
                                                        className="btn btn-outline-success px-3 super-small"
                                                       target="_blank" rel="noreferrer"
                                                    >
                                                        دانلود بارنامه
                                                    </a>
                                                </div> : ''
                                                }
                                                <div className="col-md-12 px-1 mt-2 py-3 text-right rtl border-top ">
                                                    <FontAwesomeIcon icon={faEdit}
                                                                     className='text-secondary mx-2'
                                                    />
                                                    توضیحات درخواست:
                                                    &nbsp;
                                                    <b>
                                                        {this.state.request.description}
                                                    </b>
                                                </div>
                                                <div className="col-md-12 px-1 mt-2 py-3 text-right rtl border-top ">
                                                    <FontAwesomeIcon icon={faEdit}
                                                                     className='text-info mx-2'
                                                    />
                                                    توضیحات کارشناس:
                                                    &nbsp;
                                                    <b>
                                                        {this.state.request.expert_description}
                                                    </b>
                                                </div>
                                            </div>
                                        </section>
                                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="driver-tab" data-toggle="tab"
                                                   href="#driver"
                                                   role="tab" aria-controls="profile" aria-selected="false">
                                                    راننده</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link " id="home-tab" data-toggle="tab" href="#home"
                                                   role="tab" aria-controls="home" aria-selected="true">اطلاعات
                                                    بارگیری</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link " id="profile-tab" data-toggle="tab"
                                                   href="#profile"
                                                   role="tab" aria-controls="profile" aria-selected="false">
                                                    بار</a>
                                            </li>

                                            <li className="nav-item">
                                                <a className="nav-link" id="contact-tab" data-toggle="tab"
                                                   href="#contact"
                                                   role="tab" aria-controls="contact" aria-selected="false">مستندات</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="history-tab" data-toggle="tab"
                                                   href="#history"
                                                   role="tab" aria-controls="history" aria-selected="false">تاریخچه وضعیت ها</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="myTabContent">
                                            <div className="tab-pane fade show active" id="driver" role="tabpanel"
                                                 aria-labelledby="contact-tab">
                                                {hasBackupDriver ?
                                                    <React.Fragment>
                                                        <section className="container rtl  p-3 usual-content mb-2 ">
                                                            <div className="row ">
                                                                <div
                                                                    className="col-md-3 px-3 py-3 small ">
                                                                    <img src={this.state.request.backup_driver.avatar}
                                                                         alt="Driver"
                                                                         className="rounded-circle" width={80}/>
                                                                </div>
                                                                <div
                                                                    className="col-md-3 px-3 py-3  mt-3 text-right">
                                                                    {this.state.request.backup_driver.first_name}
                                                                    &nbsp;
                                                                    {this.state.request.backup_driver.last_name}
                                                                </div>
                                                                <div
                                                                    className="col-md-3  py-3 small mt-3 ">
                                                                    شماره تماس:
                                                                    &nbsp;
                                                                    <a href={"tel:" + this.state.request.driver.mobile}>
                                                                        {this.state.request.driver.mobile}
                                                                    </a>

                                                                </div>
                                                                <div
                                                                    className="col-md-3 px-3 py-3 mt-3 text-right">
                                                                    کد ملی :
                                                                    &nbsp;
                                                                    <span className='small fw-bold'>
   {this.state.request.backup_driver.national_id}
</span>


                                                                </div>

                                                            </div>
                                                        </section>
                                                        <section className="container rtl  p-3 usual-content ">
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-4 px-3 pb-4 custom-border-bottom my-3 text-right">
                                                                    اطلاعات خودرو
                                                                </div>
                                                                <div className="col-md-8">
                                                                    &nbsp;
                                                                </div>
                                                                <div className="col-md-4 px-3 py-3  small">
                                                                    نوع خوردو:
                                                                    &nbsp;
                                                                    {this.state.request.car_type.title}
                                                                </div>
                                                                <div className="col-md-4 px-3 py-3  small">
                                                                    پلاک:
                                                                    &nbsp;
                                                                    {this.state.request.driver.cars[0].plaque}
                                                                </div>
                                                                <div className="col-md-4 px-3 py-3  small">
                                                                    رنگ:
                                                                    &nbsp;
                                                                    {this.state.request.driver.cars[0].color}
                                                                </div>
                                                                <div
                                                                    className="col-md-3  mt-5 pt-5 super-small text-center">
                                                                    آخرین دریافت موقعیت:
                                                                    <br/><br/>
                                                                    {this.state.request.driver.location.last_send}
                                                                    {
                                                                        this.state.request.driver.location.diff_send_hour > 0.5 ?
                                                                            <button className='btn btn-primary mt-2'
                                                                            onClick={this.DriverPositionRequest}
                                                                            >
درخواست ارسال  موقعیت راننده
                                                                            </button> :''
                                                                    }
                                                                    <br/>

                                                                    آدرس :
                                                                    {
                                                                        this.state.address
                                                                    }
                                                                </div>
                                                                <div className="col-md-9 mt-2 pt-2">
                                                                   {/* {hasLocation && this.state.loadMap ?
                                                                        <MapContainer
                                                                            center={[this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)]}
                                                                            zoom={13}
                                                                            scrollWheelZoom={true}
                                                                            className="driver-map px-2 rounded-more"
                                                                        >
                                                                            <TileLayer
                                                                                attribution='&copy; <a href="http://osm.org/copyright">ModernNegaresh</a> contributors'
                                                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                                            />
                                                                            <Marker
                                                                                position={[this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)]}
                                                                            />
                                                                        </MapContainer> : ''}*/}
                                                                </div>
                                                            </div>

                                                        </section>
                                                    </React.Fragment> :hasDriver ?
                                                    <React.Fragment>
                                                        <section className="container rtl  p-3 usual-content mb-2 ">
                                                            <div className="row ">
                                                                <div
                                                                    className="col-md-3 px-3 py-3 small ">
                                                                    <img src={this.state.request.driver.avatar}
                                                                         alt="Driver"
                                                                         className="rounded-circle" width={80}/>
                                                                </div>
                                                                <div
                                                                    className="col-md-3 px-3 py-3  mt-3 text-right">
                                                                    {this.state.request.driver.first_name}
                                                                    &nbsp;
                                                                    {this.state.request.driver.last_name}
                                                                </div>
                                                                <div
                                                                    className="col-md-3  py-3 small mt-3 ">
                                                                    شماره تماس:
                                                                    &nbsp;
                                                                    <a href={"tel:" + this.state.request.driver.mobile}>
                                                                        {this.state.request.driver.mobile}
                                                                    </a>

                                                                </div>
                                                                <div
                                                                    className="col-md-3 px-3 py-3 mt-3 text-right">
                                                                    کد ملی :
                                                                    &nbsp;
                                                                    <span className='small fw-bold'>
   {this.state.request.driver.national_id}
</span>


                                                                </div>

                                                            </div>
                                                        </section>
                                                        <section className="container rtl  p-3 usual-content ">
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-4 px-3 pb-4 custom-border-bottom my-3 text-right">
                                                                    اطلاعات خودرو
                                                                </div>
                                                                <div className="col-md-8">
                                                                    &nbsp;
                                                                </div>
                                                                <div className="col-md-4 px-3 py-3  small">
                                                                    نوع خوردو:
                                                                    &nbsp;
                                                                    {this.state.request.car_type.title}
                                                                </div>
                                                                <div className="col-md-4 px-3 py-3  small">
                                                                    پلاک:
                                                                    &nbsp;
                                                                    {this.state.request.driver.cars[0].plaque}
                                                                </div>
                                                                <div className="col-md-4 px-3 py-3  small">
                                                                    رنگ:
                                                                    &nbsp;
                                                                    {this.state.request.driver.cars[0].color}
                                                                </div>
                                                                {hasLocation > 0 &&
                                                                <div
                                                                    className="col-md-3  mt-5 pt-5 super-small text-center">
                                                                    آخرین دریافت موقعیت:
                                                                    <br/><br/>
                                                                    {this.state.request.driver.location.last_send}
                                                                    {
                                                                        this.state.request.driver.location.diff_send_hour > 0.5 ?
                                                                            <button className='btn btn-primary mt-2'
                                                                            onClick={this.DriverPositionRequest}
                                                                            >
درخواست ارسال  موقعیت راننده
                                                                            </button> :''
                                                                    }
                                                                    <br/>

                                                                    آدرس :
                                                                    {
                                                                        this.state.address
                                                                    }
                                                                    <div className='mt-2 fw-bold text-primary'>
                                                                        فاصله تقریبی تا مقصد:
                                                                        &nbsp;
                                                                        {this.state.distance}
                                                                        &nbsp;
                                                                        کیلومتر
                                                                    </div>
                                                                </div>}
                                                                <div className="col-md-9 mt-2 pt-2">
                                                          {/*          {hasLocation && this.state.loadMap ?
                                                                        <MapContainer
                                                                            center={[this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)]}
                                                                            zoom={13}
                                                                            scrollWheelZoom={true}
                                                                            className="driver-map px-2 rounded-more"
                                                                        >
                                                                            <TileLayer
                                                                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                                            />
                                                                            <Marker
                                                                                position={[this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)]}
                                                                            />
                                                                        </MapContainer> : ''}*/}

                                                                    {
                                                                        hasLocation && this.state.loadMap ?
                                                                    <NeshanMap
                                                                        options={{
                                                                            key: 'web.1b9521ecbf8f47fe8c1866812d07a969',
                                                                            maptype: 'neshan' ,
                                                                            poi: true,
                                                                            traffic: true,
                                                                            center: [this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)],
                                                                            zoom: 13,

                                                                        }}
                                                                        style = {{
                                                                            width : '100% !important'
                                                                        }
                                                                        }
                                                                        onInit={(L, myMap ) => {

                                                                             L.marker([this.state.request.driver.location.lat.toFixed(4), this.state.request.driver.location.lng.toFixed(4)])
                                                                                .addTo(myMap)
                                                                                .bindPopup('موقعیت راننده');


                                                                        }}
                                                                    /> : ''
                                                                    }
                                                                </div>
                                                            </div>

                                                        </section>
                                                    </React.Fragment> :
                                                    <div className='alert alert-info super-small text-center mx-4'>
                                                        هنوز راننده ای به درخواست شما اختصاص داده نشده است.
                                                    </div>
                                                }
                                            </div>
                                            <div className="tab-pane fade " id="home" role="tabpanel"
                                                 aria-labelledby="home-tab">
                                                <section className="container rtl  p-3 usual-content ">
                                                    <div className="row">
                                                        <div className="row small ">
                                                            <div className="col-md-3 px-3 py-3 ">
                                                                آدرس های بارگیری:
                                                            </div>
                                                            <div className="col-md-9 px-3 py-3 ">
                                                                {
                                                                    this.state.request.loading_addresses.map(address => {
                                                                        return (
                                                                            <div key={address.id}>
                                                                                <FontAwesomeIcon icon={faMapMarker}
                                                                                                 className='text-secondary mx-3'
                                                                                />
                                                                                {address.title + ' '}
                                                                                به آدرس:

                                                                                <b className='px-2'>

                                                                                    {address.address}
                                                                                </b>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            <div className="col-md-3 px-3 py-3 custom-border-bottom">
                                                                ساعت و تاریخ بارگیری:
                                                            </div>
                                                            <div className="col-md-9 px-3 py-3 custom-border-bottom">
                                                                <FontAwesomeIcon icon={faClock}
                                                                                 className='text-secondary mx-3'
                                                                />
                                                                {this.state.request.loading_date}
                                                                &nbsp;
                                                                -
                                                                &nbsp;
                                                                {this.state.request.loading_time}

                                                            </div>
                                                            <div className="col-md-3 px-3 py-3 ">
                                                                آدرس های تخلیه:

                                                            </div>
                                                            <div className="col-md-9 px-3 py-3 ">
                                                                {
                                                                    this.state.request.unloading_addresses.map(address => {
                                                                        return (
                                                                            <div key={address.id}>
                                                                                <FontAwesomeIcon icon={faMapMarker}
                                                                                                 className='text-secondary mx-3'
                                                                                />
                                                                                {address.title + ' '}
                                                                                به آدرس:

                                                                                <b className='px-2'>

                                                                                    {address.address}
                                                                                </b>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            <div className="col-md-3 px-3 py-3">
                                                                ساعت و تاریخ تخلیه:
                                                            </div>
                                                            <div className="col-md-9 px-3 py-3">
                                                                <FontAwesomeIcon icon={faClock}
                                                                                 className='text-secondary mx-3'
                                                                />
                                                                {this.state.request.unloading_date}
                                                                &nbsp;
                                                                -
                                                                &nbsp;
                                                                {this.state.request.unloading_time}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            </div>
                                            <div className="tab-pane fade " id="profile" role="tabpanel"
                                                 aria-labelledby="profile-tab">
                                                <section className="container rtl  p-3 usual-content ">
                                                    <div className="row ">
                                                        <div className="col-md-2 px-3 py-3 small custom-border-bottom">
                                                            محموله:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom ">
                                                            {
                                                                this.state.request.consignments.map(consignment => {
                                                                    return (
                                                                        <span key={consignment.id}
                                                                              className="badge badge-pill badge-primary bg-primary mx-2">

                                                            {consignment.title}

                                                        </span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                        <div
                                                            className="col-md-2 px-3 py-3 small custom-border-right custom-border-bottom small">
                                                            تعداد بسته:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom">
                                                            {this.state.request.pack_count}
                                                        </div>
                                                    </div>
                                                    <div className="row small">
                                                        <div className="col-md-2 px-3 py-3 small  custom-border-bottom">
                                                            عرض بار:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom">
                                                            {Math.floor(this.state.request.load_width / 100)}
                                                            &nbsp;
                                                            متر و
                                                            &nbsp;
                                                            {this.state.request.load_width - (Math.floor(this.state.request.load_width / 100) * 100)}
                                                            &nbsp;
                                                            سانتی متر
                                                        </div>
                                                        <div
                                                            className="col-md-2 px-3 py-3 small  custom-border-bottom custom-border-right">
                                                            طول بار:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom">
                                                            {Math.floor(this.state.request.load_length / 100)}
                                                            &nbsp;
                                                            متر و
                                                            &nbsp;
                                                            {this.state.request.load_length - (Math.floor(this.state.request.load_length / 100) * 100)}
                                                            &nbsp;
                                                            سانتی متر
                                                        </div>
                                                    </div>
                                                    <div className="row small">
                                                        <div className="col-md-2 px-3 py-3 small  custom-border-bottom">
                                                            ارتفاع بار:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom">
                                                            {Math.floor(this.state.request.load_height / 100)}
                                                            &nbsp;
                                                            متر و
                                                            &nbsp;
                                                            {this.state.request.load_height - (Math.floor(this.state.request.load_height / 100) * 100)}
                                                            &nbsp;
                                                            سانتی متر
                                                        </div>
                                                        <div
                                                            className="col-md-2 px-3 py-3 small  custom-border-bottom custom-border-right">
                                                            وزن بار:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom">
                                                            {Math.floor(this.state.request.load_tonnage / 1000)}
                                                            &nbsp;
                                                            تن و
                                                            &nbsp;
                                                            {this.state.request.load_tonnage - (Math.floor(this.state.request.load_tonnage / 1000) * 1000)}
                                                            &nbsp;
                                                            کیلوگرم
                                                        </div>
                                                        <div
                                                            className="col-md-2 px-3 py-3 small  custom-border-bottom custom-border-right">
                                                             نرخ توافقی:
                                                        </div>
                                                        <div className="col-md-4 px-3 py-3 custom-border-bottom">
                                                            {currencyFormat.format(this.state.request.suggested_price) }
                                                            &nbsp;
                                                            ریال
                                                        </div>

                                                    </div>
                                                </section>
                                            </div>

                                            <div className="tab-pane fade" id="contact" role="tabpanel"
                                                 aria-labelledby="contact-tab">
                                                <section className="container rtl  p-3 usual-content ">
                                                    <div
                                                        className="row  mx-md-5 p-md-5 mb-2 border rounded text-center pt-5">
                                                        <div className="col-md-4 ">
                                                            <label className="custom-file-upload">
                                                                انتخاب فایل
                                                                <input type="file" onChange={this.onDocChange}/>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-8 small mb-3 mt-2 text-secondary">
                                                            لطفا مستندات خود را در قالب فایل هایی با پسوند
                                                            .doc,
                                                            .pdf,
                                                            .jpg,
                                                            .png
                                                            ارسال فرمایید.
                                                            <div className=" text-success super-small bg-light p-2">
                                                                &nbsp;
                                                                {
                                                                    this.state.document_file ?
                                                                        " فایل انتخاب شده : " +
                                                                        this.state.document_file.name
                                                                        : ''
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="form-floating col-md-4 mt-2">
                                                            <input type="text"
                                                                   className="form-control px-5"
                                                                   id="document_title" name="document_title"
                                                                   placeholder="عنوان فایل"
                                                                   value={this.state.document_title}
                                                                   onChange={this.onInputChange}/>
                                                            <label htmlFor="document_title" className="super-small">عنوان
                                                                فایل</label>
                                                        </div>
                                                        <div className="form-floating col-md-8">

                                        <textarea className="form-control"
                                                  placeholder="توضیحات"
                                                  id="document_description"
                                                  name="document_description"
                                                  value={this.state.document_description ? this.state.document_description : ''}
                                                  onChange={this.onInputChange}
                                        />

                                                            <label htmlFor="document_description"
                                                                   className="super-small">توضیحات</label>
                                                        </div>

                                                        <div className="col-md-6 text-left mt-3">
                                                            <button className="btn btn-success p-2 w-100"
                                                                    onClick={this.onUploadClick} disabled={this.state.buttonStatus}>
                                                                <FontAwesomeIcon icon={faUpload}/>

                                                                &nbsp;
                                                                {this.state.buttonText}
                                                                <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                                                       aria-hidden="true"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="border rounded mx-md-5 p-md-5 pt-5">
                                                        {
                                                            hasDocument ?

                                                                <h3 className="small text-success text-center">
                                                                    مستندات الحاقی به درخواست
                                                                </h3>
                                                                :
                                                                <h3 className="small text-danger text-center">
                                                                   هنوز فایل یا مستنداتی به درخواست الحاق نشده است.
                                                                </h3>
                                                        }
                                                        <div
                                                            className='row text-center py-3 m-auto mt-2 transactions-header  '>
                                                            <div className="col-3">عنوان</div>
                                                            <div className="col-6">توضیحات</div>
                                                            <div className="col-3">دانلود</div>

                                                        </div>
                                                        {
                                                            this.state.request.documents.map(doc => {

                                                                return (
                                                                    <div
                                                                        className='row text-center text-dark py-3 m-auto mt-2 transactions-body  '
                                                                        key={doc.id}>
                                                                        <div className="col-3 fw-bold">
                                                                            {doc.title? doc.title.replace('-CFD0-' , '') : ''}
                                                                        </div>
                                                                        <div
                                                                            className="col-6 super-small"> {doc.description}
                                                                            {
                                                                                doc.title?
                                                                                doc.title.indexOf('-CFD0-') === -1 &&
                                                                                    <span className='text-info px-2'>
                                                                                        (
                                                                                        ارسالی از سامانه
                                                                                        )
                                                                                    </span>
                                                                                    :  <span className='text-info px-2'>
                                                                                        (
                                                                                        ارسالی از سامانه
                                                                                        )
                                                                                    </span>
                                                                            }
                                                                        </div>
                                                                        <div className="col-3 small">
                                                                            <a href={doc.path} target="_blank"
                                                                               rel="noreferrer">
                                                                                <FontAwesomeIcon
                                                                                    icon={faDownload}/>&nbsp;
                                                                                دانلود
                                                                            </a>
                                                                        </div>

                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </section>
                                            </div>
                                            <div className="tab-pane fade" id="history" role="tabpanel"
                                                 aria-labelledby="history-tab">
                                                <section className="container rtl  p-3 usual-content ">
                                                   <div className="row text-center history-head">
                                                       <div className="col-6 ">
                                                           وضعیت
                                                       </div>
                                                       <div className="col-6 ">
                                                           زمان
                                                       </div>

                                                   </div>
                                                    {
                                                    this.state.request.history.map(hist => {
                                                        return (
                                                            <div className="row text-center history-row">
                                                                <div className="col-6 ">
                                                                    {hist.status}
                                                                </div>
                                                                <div className="col-6">
                                                                    {hist.date}
                                                                </div>
                                                            </div>
                                                        )

                                                    })

                                                }
                                                </section>
                                            </div>
                                        </div>

                                    </React.Fragment>
                                    : ''
                            }
                        </div>

                    </div>
                </section>
            </React.Fragment>
        );
    }

    componentDidMount = () => {
        API.request(this.props.match.params.id)
            .then((response) => {
                const request = response.results.request;
                this.setState({request})
                if (request.driver.location) {
                    API.searchNeshanRevers(request.driver.location.lat,request.driver.location.lng)
                        .then((response) => {
                            this.setState({address : response.formatted_address})
                        })
                }
                if (this.state.request.driver.location.lng) {
                    const distance = getDistanceFromLatLonInKm(this.state.request.driver.location.lat,this.state.request.driver.location.lng,this.state.request.unloading_addresses[0].lat,this.state.request.unloading_addresses[0].lng);
                    this.setState({ distance})
                }


                setTimeout(() => {
                    this.setState({loadMap: 1 })
                }, 1500);
            })
            .catch((error) => {
               // toast.error(error.response.data.user_message);
            });



        setInterval (() => {
            API.request(this.props.match.params.id)
                .then((response) => {
                    const request = response.results.request;
                    this.setState({request})
                    API.searchNeshanRevers(request.driver.location.lat,request.driver.location.lng)
                        .then((response) => {
                            this.setState({address : response.formatted_address})

                        })
                    setTimeout(() => {
                        this.setState({loadMap: 1})
                    }, 1500);
                })
                .catch((error) => {
                   // toast.error(error.response.data.user_message);
                });
        },300000)

    }
}

export default RequestProfile;